<template>
  <radio-input :name="name" :label="label" :options="options"
               :required="required" @input="onInput" :val="val"
  />
</template>

<script>
import customInputMixin from '@/components/frontoffice/form/customInput/mixin'
import radioInput from '@/components/frontoffice/form/baseInput/radio'

export default {
  components: {
    radioInput
  },

  mixins: [customInputMixin],

  props: {
    options: Array,
    val: [Array, String, Number]
  },

  methods: {
    onInput (newVal) {
      this.$emit('input', newVal)
    }
  }
}
</script>
